import Config from '../config';
import axios from "axios/index";
import {notification} from '../helpers';


export function put(data) {

    if (Number.isInteger(parseInt(data.id, 10))) {
        return (dispatch) => {
            dispatch({
                type: 'WHEELCHANGERS_UPDATE_INPROGRESS',
                payload: data
            });
            return axios.put(Config.api.getDomain() + 'wheelchanger/put', data, Config.api.getConfig()).then((response) => {
                dispatch({
                    type: 'WHEELCHANGERS_UPDATE_SUCCESS',
                    payload: response
                });
                notification("Grupp är ändrad!");
                dispatch({
                    type: 'REFRESH_FETCH_TRUE',
                    payload: {
                        key:"stationGroups"
                    }
                });
                return Promise.resolve(true);
            }).catch(error => {

                dispatch({
                    type: 'WHEELCHANGERS_UPDATE_FAILURE',
                    payload: error
                });
                notification("Gruppuppdatering misslyckades");
                return error;
            });
        }
    } else {

        return (dispatch) => {
            dispatch({
                type: 'WHEELCHANGERS_UPDATE_FAILURE',
                payload: {"message": "No group id"}
            });
            notification("no group id passed");
        };
    }
}


export function post(data) {

    return (dispatch) => {

        dispatch({
            type: 'WHEELCHANGERS_CREATE_INPROGRESS',
            payload: data
        });

        return axios.post(Config.api.getDomain() + 'wheelchanger', data, Config.api.getConfig())
            .then(response => {
                dispatch({
                    type: 'REFRESH_FETCH_TRUE',
                    payload: {key:"stationGroups"}
                });
                notification('Grupp skapad!');
                dispatch({
                    type: 'WHEELCHANGERS_CREATE_SUCCESS',
                    payload: response
                });
            })
            .catch(error => {
                console.log(error);
                if (typeof(error.response)!=="undefined" && typeof(error.response.data)!=="undefined"){
                    let errorCodes = error.response.data;
                    console.log(errorCodes);
                    notification('Misslyckades med att skapa gruppen! '+errorCodes.message);
                    dispatch({
                        type: 'WHEELCHANGERS_CREATE_FAILURE',
                        payload: error
                    });
                } else {
                    notification('Misslyckades med att skapa gruppen! ');
                }

            });
    }

}


export function destroy(id) {
    if (Number.isInteger(parseInt(id, 10))) {
        return (dispatch) => {
            return axios.delete(Config.api.getDomain() + 'admin/deletewheelchanger/' + id, Config.api.getConfig()).then((response) => {
                dispatch({
                    type: 'WHEELCHANGER_DESTROY_SUCCESS',
                    payload: response
                });
                dispatch({
                    type: 'REFRESH_FETCH_TRUE',
                    payload: {
                        key:"stationGroups"
                    }
                });
                notification("Raderades framgångsrikt!");
                return Promise.resolve(true);
            }).catch(error => {
                dispatch({
                    type: 'WHEELCHANGER_DESTROY_FAILURE',
                    payload: error
                });
                notification("Raderade misslyckades!");
                return error;
            });
        }
    } else {

        return (dispatch) => {
            dispatch({
                type: 'WHEELCHANGER_DESTROY_FAILURE',
                palyload: {"message": "No wheelchanger id passed"}
            });
        };
    }
}




// WEBPACK FOOTER //
// ./src/actions/wheelChangers.js